module.exports = __webpack_public_path__ + "img/i_h2_function2.246b5be4.svg";